import {
  QuestionEditorProps,
  QuizEditField,
} from '@/modules/corporate/modules/questions/fields/types';
import { QuestionSubTypeEnum, QuestionTypeEnum } from '@/types/schema';

import Editor from '../../../components/Editor';
import EditorOptionsList from '../../EditorOptionsList';

const PictureChoiceEditField: QuizEditField = {
  Editor: (props: QuestionEditorProps) => (
    <Editor
      key={props.question.options?.set.length}
      EditorOptionsList={EditorOptionsList}
      isMultiSelect={props.question.subType === QuestionSubTypeEnum.MultiSelect}
      {...props}
    />
  ),
  type: QuestionTypeEnum.PictureMultipleChoiceQuestion,
};

export default PictureChoiceEditField;
